/* tslint:disable */
/* eslint-disable */

/**
 * 1 = Geplant (Geplant)
 * 
 * 401130001 = Freigegeben (Freigegeben)
 * 
 * 805290000 = Uberwiesen (Überwiesen)
 * 
 * 2 = Storniert (Storniert)
 */
import {EnumValue} from "@/core/models/enumvalue.model"
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

export enum AceZahlungAceZahlungEnumsAceZahlungStatuscode {
 Geplant = 1,
 Freigegeben = 401130001,
 Uberwiesen = 805290000,
 Storniert = 2
}

marker([
    "Enum.AceZahlungAceZahlungEnumsAceZahlungStatuscode.Geplant",
    "Enum.AceZahlungAceZahlungEnumsAceZahlungStatuscode.Freigegeben",
    "Enum.AceZahlungAceZahlungEnumsAceZahlungStatuscode.Uberwiesen",
    "Enum.AceZahlungAceZahlungEnumsAceZahlungStatuscode.Storniert"
]);

export namespace AceZahlungAceZahlungEnumsAceZahlungStatuscode
{
    class DataSets
    {
        static AceZahlungAceZahlungEnumsAceZahlungStatuscodeDataSet: Array<EnumValue> = new Array<EnumValue>(
            new EnumValue("Geplant", 1, "Geplant"),
            new EnumValue("Freigegeben", 401130001, "Freigegeben"),
            new EnumValue("Uberwiesen", 805290000, "Überwiesen"),
            new EnumValue("Storniert", 2, "Storniert"),
        )
    }

    export function getAsDataset() {
        return DataSets.AceZahlungAceZahlungEnumsAceZahlungStatuscodeDataSet;
    }
}
